export default __webpack_public_path__ + "static/media/projects-3.6928b994.jpg";